import { createSelector } from "reselect";
import { sectionsSelector } from "../../sections_selector";

export const populationSectionSelector = createSelector(
  sectionsSelector,
  sections => {
    return sections.population;
  }
);
